<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.fractionalTrading.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy">
        <span translate="tdWb.modalNotification.fractionalTrading.DESCRIPTION"></span>
        <a tdWbHref="link_modal_trading_fractional_shares"
           translate="tdWb.modalNotification.fractionalTrading.LINK_TEXT">
        </a>
      </p>
    </div>
    <div class="td-wb-modal-notification--image-container td-wb-modal-notification--success-background">
      <img tdWbModalNotificationImage
           [src]="'tdWb.modalNotification.fractionalTrading.IMAGE_PATH' | translate"
           [attr.alt]="'tdWb.modalNotification.fractionalTrading.IMAGE_ALT' | translate"
           aria-hidden="true"
           class="td-wb-modal-notification--image-small"
      />
    </div>
  </div>
</div>
